import { NgClass } from "@angular/common";
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { CollapseFilterComponent } from "@app/components/collapse-filter/collapse-filter.component";
import { isNullish } from "@commonHelpers/math-utils";
import { TranslatePipe } from "@commonNodeModules/@ngx-translate/core";
import { TagModel } from "@interfaces/iTagFilter";
import { TranslationService } from "@services/translation.service";
import { ResetFilterComponent } from "../../components/reset-filter/reset-filter.component";


@Component({
	selector: "app-tagviewer",
	templateUrl: "./tagviewer.component.html",
	styleUrls: ["./tagviewer.component.scss"],
	imports: [ResetFilterComponent, CollapseFilterComponent, NgClass, TranslatePipe]
})
export class TagviewerComponent implements OnChanges {

	@Output() tagClicked: EventEmitter<TagModel> = new EventEmitter<TagModel>();
	@Output() resetFilter = new EventEmitter();
	@Input() clickable: boolean;
	@Input() selectedTags: TagModel[];
	@Input() tags: TagModel[];
	@Input() hideHeader: boolean;
	@Input() headerKey;
	@Input() emptySearchResults = false;
	@Input() globalSearchView = false;
	public collapsed = false;
	public sortedTags: TagModel[] = []
	public sustainabilityTagId = 15; // Tag "Nachhaltigkeit" -> Nachhaltigkeitslogo im Tag anzeigen
	public dgnbTagId = 64; // Tag "DGNB" -> Nachhaltigkeitslogo im Tag anzeigen

	constructor(
		private translationService: TranslationService
	) { }


	ngOnChanges(changes: SimpleChanges): void {
		this.sortedTags = this?.tags?.sort((a, b) => this.translationService.getByKey(a.displaystring).localeCompare(this.translationService.getByKey(b.displaystring)))
	}

	onTagClicked = (tag: TagModel): void => {
		this.tagClicked.emit(tag);
	};

	isTagSelected(tag: TagModel): boolean {
		return this.selectedTags?.find(st => st.id === tag.id) !== undefined;
	}

	public get hasSomeChecked() {
		return !isNullish(this.selectedTags) && this.selectedTags?.length > 0;
	}

	public collapse(isCollapsed: boolean) {
		this.collapsed = isCollapsed;
	}
}
